<template>
  <div class="content-page">
    <div class="mian-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox" v-loading="loading">
          <div class="re-contentBox">
            <div class="textBox">
              <el-form :model="ruleForm" :label-position="labelPosition" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm search-items">
                <el-form-item label="申请类型" prop="applicantCategory" class="col1-2">
                  <el-select v-model="ruleForm.applicantCategory" style="width: 100%">
                    <el-option value="1" key="1" label="个人申请"></el-option>
                    <el-option value="2" key="2" label="法人/组织申请"></el-option>
                  </el-select>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item :label="nameText" prop="loginName" class="col1-2">
                  <el-input :placeholder="`请输入${nameText}`" v-model.trim="ruleForm.loginName" maxlength="20"></el-input>
                </el-form-item>
                <div class="col1-2 flexEnd text-width pt15">
                  <div class="tiptext">（请输入非空格字符或汉字）</div>
                </div>
                <el-form-item label="证件类型" prop="identificationType" disabled class="col1-2">
                  <el-select v-model="ruleForm.identificationType" disabled style="width: 100%">
                    <el-option value="1001001" key="1001001" label="身份证"></el-option>
                  </el-select>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="证件号码" prop="identificationCard" disabled class="col1-2">
                  <el-input :placeholder="`请输入身份证号码`" v-model.trim="ruleForm.identificationCard" maxlength="18"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <!-- <el-form-item prop="fileListJpg2" class="upload-identificationFile col1-2">
                  <span slot="label">身份证人像面</span>
                  <el-upload class="upload-identiFile" action="" name="file" :http-request="param => handleUpload(param, 4)" :before-upload="param => beforeUpload(param, 4)" :on-remove="handleRemove" :limit="1" :on-exceed="handleExceed" :file-list="ruleForm.fileListJpg2" accept=".jpg,.jpeg,.png">
                    <div class="identiFile-btn">选择文件</div>
                  </el-upload>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item prop="fileListJpg" class="upload-identificationFile col1-2">
                  <span slot="label">身份证国徽面</span>
                  <el-upload class="upload-identiFile" action="" name="file" :http-request="param => handleUpload(param, 3)" :before-upload="param => beforeUpload(param)" :on-remove="handleRemoveGh" :limit="1" :on-exceed="handleExceed" :file-list="ruleForm.fileListJpg" accept=".jpg,.jpeg,.png">
                    <div class="identiFile-btn">选择文件</div>
                  </el-upload>
                </el-form-item>
                <div class="col1-2"></div> -->
                <!--              <el-form-item label="设置查询密码" prop="inquirePwd"  class="col1-2">-->
                <!--                <el-input :maxlength="10" placeholder="设置查询密码" type="password" v-model.trim="ruleForm.inquirePwd" autocomplete="new-password"></el-input>-->
                <!--              </el-form-item>-->
                <!--              <div class="col1-2 flexEnd text-width pt15">-->
                <!--                <div class="tiptext">-->
                <!--                  （密码为6-10位，请务必牢记，查询需此密码）-->
                <!--                </div>-->
                <!--              </div>-->
                <!--              <el-form-item label="确认密码" prop="checkPass" class=" col1-2">-->
                <!--                <el-input :maxlength="10" placeholder="确认密码" type="password" v-model.trim="ruleForm.checkPass" autocomplete="new-password"></el-input>-->
                <!--              </el-form-item>-->
                <!--              <div class="col1-2"></div>-->
                <el-form-item label="手机号码" prop="phone" class="col1-2">
                  <el-input placeholder="请输入手机号码" v-model.trim="ruleForm.phone" maxlength="20"></el-input>
                </el-form-item>
                <div v-no-more-div v-if="!isDisabled" class="col1-2 flexEnd pt10">
                  <div v-no-more-div @click="getNumberCode" class="codebtn">{{ content }}</div>
                </div>
                <div v-else class="col1-2 flexEnd pt10">
                  <div class="codebtn-gary">{{ content }}</div>
                </div>
                <el-form-item label="手机验证码" prop="verificationCode" class="phone col1-2">
                  <el-input placeholder="请输入验证码" v-model.trim="ruleForm.verificationCode" maxlength="8"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- <div class="re-contentBox" v-if="isFaceRecognition"  v-loading="qrcodeLoading">
              <img :src="qrcodeUrl" alt="小程序二维码" style="width: 280px; height: 280px" />
          </div> -->
          <div class="btnLists">
            <div v-no-more-div v-if="!isFaceRecognition" class="primary-btn" @click="submitForm('ruleForm')">人脸识别</div>
            <div v-no-more-div v-if="isFaceRecognition" class="primary-btn" @click="returnRegisterPage">返回录入页面</div>
            <div v-no-more-div v-else class="border-btn" style="margin-left: 20px" @click="$router.push('/howApply')">返回上一页</div>
          </div>
        </div>
      </div>
    </div>
    <faceIdTip ref="faceIdTip" @nextTep="nextTep" />
  </div>
</template>

<script>
import axios from 'axios'
import { ocrIdCardCheck, uuid } from '@/utils'
import faceIdTip from '@/components/face/faceIdTip.vue'
import Api from '@api/api'
import { addAntiReplayParams } from '@/utils/antireplay'
let fileloading = null
export default {
  data () {
    // var validatePass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入密码'))
    //   } else if (value.length < 6) {
    //     callback(new Error('密码长度为6-10位'))
    //   } else {
    //     if (this.ruleForm.checkPass !== '') {
    //       this.$refs.ruleForm.validateField('checkPass')
    //     }
    //     callback()
    //   }
    // }
    // var validatePass2 = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请再次输入密码'))
    //   } else if (value.length < 6) {
    //     callback(new Error('密码长度为6-10位'))
    //   } else if (value !== this.ruleForm.inquirePwd) {
    //     callback(new Error('两次输入密码不一致!'))
    //   } else {
    //     callback()
    //   }
    // }
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (/\s+/g.test(this.ruleForm.loginName) || value === '') {
        callback(new Error('请输入正确的' + this.nameText + '名称'));
      } else {
        callback();
      }
    };

    var validateIdCard = (rule, value, callback) => {
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard) || value === '') {
        callback(new Error('请输入正确的证件号码'));
      } else {
        callback();
      }
    };

    const moduleCodeSwitch = () => {
      switch (localStorage.getItem('oprate')) {
        case 'apply':
          return '1'
          break
        case 'search':
          return '2'
          break
        case 'revokeApply':
          return '3'
          break
      }
    };

    return {
      nameText: '申请人',
      fileRx: null,
      fileGh: null,
      isFaceRecognition: false, // 是否进入人脸识别页面
      isDisabled: false, // 控制按钮是否可以点击
      content: '获取验证码', // 发送验证码按钮的初始显示文字
      timer: null, // 定时器
      count: null,
      caseOrderNo: uuid(), // 生成的案件流水号
      identificationApplicant: uuid(), // 申请人id 都uuid生成
      ruleForm: {
        applicantCategory: '1',
        fileListJpg: [],
        identificationCard: '',
        fileListJpg2: [],
        identificationType: '1001001',
        loginName: '',
        phone: '',
        verificationCode: null,
        moduleCode: moduleCodeSwitch(),
        fileRx: null,
        fileGh: null,
        id: '' // 验证码失效时需要传
      },
      rules: {
        loginName: [{ required: true, validator: validateName, trigger: 'blur' }],
        applicantCategory: [{ required: true, message: '请选择申请人类型', trigger: 'blur' }],
        identificationType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        fileListJpg: [{ required: true, message: '身份证国徽面不能为空', trigger: 'blur' }],
        fileListJpg2: [{ required: true, message: '身份证人像面不能为空', trigger: 'blur' }],
        identificationCard: [{ required: true, validator: validateIdCard, trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      labelPosition: 'left',
      qrcodeUrl: '',
      qrcodeId: '',
      authenticatedTimer: null,
      qrcodeLoading: false,
      loading: false
    }
  },
  components: {
    faceIdTip
  },
  watch: {
    'ruleForm.applicantCategory': function (val) {
      console.log(val)
      if (val == 1) {
        this.nameText = '申请人';
      } else {
        this.nameText = '联系人';
      }
    }
  },
  created () {

  },
  // 退出页面关闭定时器
  beforeDestroy () {
    clearTimeout(this.authenticatedTimer)
    this.authenticatedTimer = null
  },
  mounted () {
    if (document.body.clientWidth <= 750) {
      this.labelPosition = 'top';
    } else {
      this.labelPosition = 'left';
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth <= 750) {
          this.labelPosition = 'top';
        } else {
          this.labelPosition = 'left';
        }
      })();
    };
  },
  methods: {
    nextTep () {
      this.loading = true;
      this.login();
    },
    handleRemoveGh () {
      this.ruleForm.fileListJpg = [];
    },
    handleRemove () {
      this.ruleForm.fileListJpg2 = [];
    },
    // 上传文件之前的钩子
    beforeUpload (file, kindType) {
      const isLt100MB = file.size / 1024 / 1024 < 100;
      const a = file.name;
      const b = ['.jpg', '.gif', '.png', '.jpeg'];
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase());
      if (!isLt100MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false;
        }
        this.$message({
          message: '上传文件大小不能超过 100MB!',
          type: 'warning',
          center: true
        });
        return false;
      }
      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false;
        }
        this.$message({
          message: '上传文件格式必须为1.jpg 2.jpeg 9.png',
          type: 'warning',
          center: true
        });
        return false;
      }
      if (!this.ruleForm.identificationCard) {
        this.$message({
          message: '请先输入身份证号！',
          type: 'warning',
          center: true
        });
        return false;
      }
      if (kindType == 4) {
        if (!this.ruleForm.loginName) {
          this.$message({
            message: '请先输入申请人姓名！',
            type: 'warning',
            center: true
          });
          return false;
        }
      }
    },

    // 限制文件上传个数
    handleExceed (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    // 自定义上传
    handleUpload (param, kindType) {
      fileloading = this.$loading({
        lock: true,
        text: '身份证校验中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (kindType == '4') {
        ocrIdCardCheck(param.file, this.ruleForm.loginName, this.ruleForm.identificationCard, null, res => {
          if (res.data.data) {
            this.uploadHandle(param, kindType);
          } else {
            this.$message.warning('请确认您的证件图片为本人原件且无破损');
            this.ruleForm.fileListJpg2 = [];
            fileloading.close();
          }
        });
      } else if (kindType == '3') {
        ocrIdCardCheck(param.file, this.ruleForm.loginName, this.ruleForm.identificationCard, 1, res => {
          if (res.data.data) {
            this.uploadHandle(param, kindType);
          } else {
            this.$message.warning('请确认您的证件图片保持国徽清晰且无破损');
            this.ruleForm.fileListJpg = [];
            fileloading.close();
          }
        });
      } else {
        this.uploadHandle(param, kindType);
      }
    },
    uploadHandle (param, kindType) {
      const formData = new FormData();
      formData.append('caseOrderNo', this.caseOrderNo);
      formData.append('evidenceName', param.file.name);
      formData.append('evidence', param.file);
      formData.append('file', param.file);
      formData.append('kindType', kindType); // 证据材料类型（0证件照1具体行政行为材料2其他补充材料 3 身份证反面 4身份证正面）
      formData.append('identificationApplicant', this.identificationApplicant);
      Api.appletsUpload(formData)
        .then(({ data }) => {
          debugger;
          console.log(data, param);
          param.file.evidenceId = data.data.id;
          param.file.id = data.data.id;
          const fileListJpg = [];
          data.data.showPath = data.data.showPath.replace('landing.iflysec.com:80', 'landing.iflysec.com');
          // fileListJpg.push({...file, ...resData.data})
          fileListJpg.push({
            ...data.data,
            url: data.data.showPath,
            name: data.data.evidenceName,
            thumb: data.data.showPath,
            type: param.file.type
          });
          const self = this;
          const reader = new FileReader();
          let tempFile = null;
          reader.readAsDataURL(param.file);
          reader.onload = function (e) {
            tempFile = e.target.result;
            console.log(tempFile);
            if (kindType == '3' || kindType == '0') {
              self.ruleForm.fileListJpg = fileListJpg;
              if (kindType === '3') {
                self.ruleForm.fileGh = tempFile;
              }
            } else {
              self.fileRx = param.file;
              self.ruleForm.fileRx = tempFile;
              self.ruleForm.fileListJpg2 = fileListJpg;
            }
          };
          fileloading.close();
        })
        .catch(() => {
          fileloading.close();
        });
    },
    // 获取验证码
    getNumberCode () {
      // 如果不是法人则校验身份证
      // 校验身份证
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard)) {
        this.$message.error('请输入正确的证件号码');
        return;
      }

      // 校验手机号
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        this.$message.error('请输入正确的手机号码');
        return;
      }
      if (!this.ruleForm.loginName) {
        this.$message.error('请填写完整后发送验证码');
        return;
      }
      this.isDisabled = false;

      // 准备请求参数
      const requestParams = {
        phone: this.ruleForm.phone,
        identificationCard: this.ruleForm.identificationCard,
        id: this.ruleForm.id,
        loginText: ''
      };

      // 添加防重放攻击参数（签名、nonce、timestamp）
      const secureParams = addAntiReplayParams(requestParams);

      Api.getcode(secureParams).then(res => {
        this.isDisabled = false;
        this.ruleForm.id = res.data.data;
        if (res.data.code == 0 && res.data.data) {
          const TIME_COUNT = 60;
          this.count = TIME_COUNT;
          this.timer = window.setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.isDisabled = true;
              this.count--;
              this.content = this.count + 's后重新获取';
            } else {
              this.isDisabled = false;
              this.content = '获取验证码';
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    login () {
      // 人口库校验
      const applicantInfoListCal = [];
      applicantInfoListCal.push({
        name: this.ruleForm.loginName,
        id: this.ruleForm.identificationCard
      });
      const param = [...applicantInfoListCal];
      // localStorage.setItem('sessionId', uuid());
      Api.saveLoginInfo({ ...this.ruleForm, loginText: '' }).then(res => {
        this.loading = false;
        if (res.data.code === '0') {
          this.$cookie.set('LoginPhone', this.ruleForm.phone);
          localStorage.setItem('applicantCategory', this.ruleForm.applicantCategory); // 存储申请人类型
          localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
          this.$router.push({
            name: 'NewCase',
            query: {
              name: 'Register',
              caseOrderNo: this.caseOrderNo,
              identificationApplicant: this.identificationApplicant
            }
          })
        }
      })
      .catch(() => {
        this.loading = false;
      })
      .finally(() => {
        this.loading = false;
      })
    },
    // 获取小程序二维码
    getCode (access_token) {
      console.log(access_token);

      // 获取用户id
      Api.postUserFaceInsert({
        name: this.ruleForm.loginName,
        idNumber: this.ruleForm.identificationCard
      }).then(res => {
        console.log(res);

        this.qrcodeId = res.data.data
        axios
          .post(
            '/wxapi/wxa/getwxacodeunlimit?access_token=' + access_token,
            {
              page: 'pages/face/face',
              scene: this.qrcodeId,
              width: 280
            },
            {
              responseType: 'blob' // 关键：设置响应类型为blob
            }
          )
          .then(res => {
            console.log(res)
            // 创建blob URL
            const imageUrl = URL.createObjectURL(res.data)
            // 将URL赋值给data中的变量，用于在模板中显示
            this.qrcodeUrl = imageUrl
            this.getUserFaceAuthenticated()
          })
          .catch(err => {
            console.error('获取二维码失败:', err)
          })
          .finally(() => {
            this.qrcodeLoading = false
          })
      })
    },
    // 轮询判断认证是否完成
    getUserFaceAuthenticated () {
      if (this.authenticatedTimer) {
        clearTimeout(this.authenticatedTimer)
        this.authenticatedTimer = null
      }
      Api.getUserFaceAuthenticated(this.qrcodeId).then(res => {
        console.log('判断是否人脸识别已完成成功or 失败', res)
        if (res.data.data == 0) {
          this.authenticatedTimer = setTimeout(() => {
            this.getUserFaceAuthenticated()
          }, 1000)
        } else if (res.data.data == 1) {
          this.login()
        } else if (res.data.data == 2) {
          this.$message.error('人脸识别失败')
          this.returnRegisterPage()
        } else {
          this.$message.error('网络错误')
        }
      })
    },
    returnRegisterPage () {
      this.isFaceRecognition = false
      clearTimeout(this.authenticatedTimer)
      this.authenticatedTimer = null
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 校验手机验证码
          Api.checkCerificationCode({
            loginName: this.ruleForm.loginName,
            identificationType: this.ruleForm.identificationType,
            identificationCard: this.ruleForm.identificationCard,
            phone: this.ruleForm.phone,
            verificationCode: this.ruleForm.verificationCode,
            id: this.ruleForm.id, // 验证码失效时需要传
            loginText: ''
          }).then(({ data }) => {
            if (data.code == 0) {
              // 存储申请人信息
              localStorage.setItem('applicantCategory', this.ruleForm.applicantCategory); // 存储申请人类型
              localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
              this.$refs.faceIdTip.open()

              // this.isFaceRecognition = true
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-contentBox {
  padding: 60px 135px 80px;
  height: auto;
  .re-contentBox {
    overflow: auto;
    min-height: 380px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    justify-content: center;
    .textBox {
      width: 80%;
      .tiptext {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 37px;
        margin-left: 5px;
      }
      .codebtn {
        width: 105px;
        height: 30px;
        background: #5a89fd;
        border-radius: 4px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 5px;
        margin-left: 10px;
        cursor: pointer;
      }
      .codebtn-gary {
        width: 105px;
        height: 30px;
        background: #ccc;
        border-radius: 4px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 5px;
        margin-left: 10px;
        cursor: not-allowed;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .main-contentBox {
    padding: 60px 80px 80px;
  }
  .tiptext {
    font-size: 12px !important;
  }
  .el-input {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 750px) {
  .main-contentBox {
    padding: 60px 40px 80px;
  }
  .main-contentBox .re-contentBox {
    backdrop-filter: none;
  }
  .re-contentBox {
    padding: 20px 0;
    .el-form-item__content {
      margin-bottom: 0 !important;
      margin-left: 10px !important;
    }
    ::v-deep .el-form-item__label {
      padding: 0px !important;
    }
    .flexEnd {
      display: flex;
      align-items: center;
    }
    .pt10 {
      padding-top: 10px;
    }
    .pt15 {
      padding-top: 15px;
    }
  }
}

.upload-identificationFile {
  .upload-identiFile {
    display: flex;
    background-color: rgb(223, 240, 253);
    border-radius: 3px;
    height: 40px;
    width: 100%;
    align-items: center;
    .identiFile-btn {
      background-color: #5a9cff;
      height: 24px;
      width: 100%;
      line-height: 23px;
      color: white;
      border-radius: 3px;
      font-size: 12px;
      margin-left: 3px;
    }
    ::v-deep .el-upload-list {
      margin-left: 5px;
      width: 70%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    ::v-deep .el-upload-list__item:first-child {
      margin-top: 0px;
    }
    ::v-deep .el-upload--text {
      width: 100%;
    }
  }
}
@media screen and (max-width: 500px) {
  .main-contentBox {
    padding: 60px 10px 80px;
  }
  .re-contentBox {
    .text-width {
      width: 100% !important;
      padding-top: 0 !important;
    }
    .el-form-item {
      margin-bottom: 0 !important;
    }
    ::v-deep .el-form-item__error {
      position: static !important;
    }
    .pt10 {
      padding-top: 36px !important;
    }
  }
  .primary-btn,
  .border-btn {
    width: 100px;
    font-size: 14px;
  }
}
@media screen and (max-width: 300px) {
  .el-form-item {
    width: 100%;
  }
  .re-contentBox .pt10 {
    padding-top: 10px !important;
  }
}
</style>
